import { call } from 'redux-saga/effects';

export function* withSagaName(name: string, saga: () => Generator) {
  try {
    // `call` keeps the feature a child task, so a crashing forked worker
    // propagates back here; `yield*` would inline it and bypass this catch.
    yield call(saga);
  } catch (error) {
    // Thrown values may not be extensible Errors (janus.js once rejected plain
    // objects); stamping a frozen one would throw the real error away.
    if (error && typeof error === 'object' && Object.isExtensible(error)) {
      (error as { sagaName?: string }).sagaName = name;
    }
    throw error;
  }
}
